import { useRef, useState } from "react";
import { X, Copy, MessageCircle } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "sonner";

export default function ShareArtistDialog({ artist, url, onClose }) {
  const [copied, setCopied] = useState(false);
  const canvasRef = useRef(null);
  const waText = encodeURIComponent(
    `Ciao! Ti giro la scheda di ${artist.name} (${artist.discipline}) di ArtVision · NMA Agency: ${url}`
  );
  const wa = `https://wa.me/?text=${waText}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copiato");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Impossibile copiare");
    }
  };

  const download = () => {
    const c = canvasRef.current?.querySelector("canvas");
    if (!c) return;
    const link = document.createElement("a");
    link.download = `${artist.name.replace(/\s+/g, "_")}-QR.png`;
    link.href = c.toDataURL("image/png");
    link.click();
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4"
      data-testid="share-dialog"
      onClick={onClose}
    >
      <div
        className="av-card p-6 max-w-md w-full relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-[#A39E93] hover:text-[#F7F4EE]"
          data-testid="share-close"
        >
          <X size={18} />
        </button>
        <span className="av-eyebrow">Condividi</span>
        <h3 className="font-serif-display text-2xl mt-2">{artist.name}</h3>
        <p className="text-xs text-[#A39E93]">{artist.discipline}</p>

        <div
          ref={canvasRef}
          className="mt-6 flex justify-center bg-[#F7F4EE] rounded-xl p-5"
          data-testid="share-qr"
        >
          <QRCodeCanvas
            value={url}
            size={220}
            bgColor="#F7F4EE"
            fgColor="#141210"
            includeMargin={false}
          />
        </div>

        <div className="flex flex-col gap-2 mt-5">
          <a
            href={wa}
            target="_blank"
            rel="noreferrer"
            className="av-pill av-pill-gold justify-center"
            data-testid="share-whatsapp"
          >
            <MessageCircle size={14} /> Condividi su WhatsApp
          </a>
          <button
            onClick={copy}
            className="av-pill av-pill-ghost justify-center text-sm"
            data-testid="share-copy"
          >
            <Copy size={14} /> {copied ? "Copiato ✓" : "Copia link"}
          </button>
          <button
            onClick={download}
            className="text-xs text-[#A39E93] hover:text-[#E5A93C] mt-1"
            data-testid="share-download"
          >
            Scarica il QR
          </button>
        </div>
      </div>
    </div>
  );
}
